var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SettingsIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.4,0.4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16.25C0 7.27537 7.27537 0 16.25 0H63.75C72.7246 0 80 7.27537 80 16.25V63.75C80 72.7246 72.7246 80 63.75 80H16.25C7.27537 80 0 72.7246 0 63.75V16.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58 16C58 13.7909 56.2091 12 54 12C51.7909 12 50 13.7909 50 16V22V28C50 30.2091 51.7909 32 54 32C56.2091 32 58 30.2091 58 28V26H65C67.2091 26 69 24.2091 69 22C69 19.7909 67.2091 18 65 18H58V16ZM11 22C11 19.7909 12.7909 18 15 18H42C44.2091 18 46 19.7909 46 22C46 24.2091 44.2091 26 42 26H15C12.7909 26 11 24.2091 11 22ZM11 59C11 56.7909 12.7909 55 15 55H29C31.2091 55 33 56.7909 33 59C33 61.2091 31.2091 63 29 63H15C12.7909 63 11 61.2091 11 59ZM45 53V55H65C67.2091 55 69 56.7909 69 59C69 61.2091 67.2091 63 65 63H45V65C45 67.2091 43.2091 69 41 69C38.7909 69 37 67.2091 37 65V59V53C37 50.7909 38.7909 49 41 49C43.2091 49 45 50.7909 45 53ZM11 40C11 37.7909 12.7909 36 15 36H25V34C25 31.7909 26.7909 30 29 30C31.2091 30 33 31.7909 33 34V46C33 48.2091 31.2091 50 29 50C26.7909 50 25 48.2091 25 46V44H15C12.7909 44 11 42.2091 11 40ZM41 36C38.7909 36 37 37.7909 37 40C37 42.2091 38.7909 44 41 44H65C67.2091 44 69 42.2091 69 40C69 37.7909 67.2091 36 65 36H41Z",
    fill: "url(#paint0_linear_1720_6116)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1720_6116",
    x1: 37.4107,
    y1: 69,
    x2: 29.4028,
    y2: 11.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00274D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00274D",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettings);
export default __webpack_public_path__ + "static/media/IconSettings.8ecf5a82d0e2ccc7ae151546be4fc710.svg";
export { ForwardRef as ReactComponent };